<template>
  <div>
    <modal id="modal-new-setup-package" v-model="modal" :backdrop="false" class="skintestblock" size="lg">
      <h4 slot="title" class="smalltitle">{{ getTitleModal }}</h4>
      <div class="block-body">
        <div class="prolabel note">Name</div>
        <div class="profield"><input v-model="serviceItem.name" type="text"></div>
        <div class="prolabel note">
          Permission
          <label class="inline-checkbox">
            <input v-model="allSelected" type="checkbox" @click="selectAll">
            <strong>Check All</strong>
          </label>
        </div>
        <div class="profield">

        </div>
        <div class="" style="display: block;width: 100%;font-size: 13px">
          <div class=" radiogroup" style="text-transform: uppercase !important;">
            <div v-for="permission in listPermissions" class="col-item-permission">
              <label :title="getTitlePermission(permission)" class="inline-checkbox">
                <input v-if="permission.code"
                       v-model="serviceItem.permissions"
                       :value="permission.code"
                       type="checkbox"
                       @click="selectPermission(permission.code, permission)"
                >
                <strong :title="permission.hover">{{ permission.name }}</strong>
                <!--                <a v-if="permission.hasLimit" class="item-limit" href="javascript:void(0)"-->
                <!--                   @click.prevent="showLimitModal(permission)">Set Filter</a>-->
              </label>
              <div v-for="subPermission in permission.children"
                   v-if="permission.children" :title="getTitlePermission(subPermission)"
                   class="sub-permission"
              >
                <label class="inline-checkbox">
                  <input v-model="serviceItem.permissions"
                         :value="subPermission.code"
                         v-if="subPermission.code"
                         type="checkbox"
                         @click="selectPermission(subPermission.code,permission)"
                  >
                  <span :title="subPermission.hover">{{ subPermission.name }}</span>
                  <!--                  <a v-if="subPermission.hasLimit" class="item-limit" href="javascript:void(0)"-->
                  <!--                     @click.prevent="showLimitModal(subPermission)">Set Filter</a>-->
                </label>
                <div v-for="minPermission in subPermission.children"
                     v-if="subPermission.children" :title="getTitlePermission(subPermission)"
                     class="sub-sub-permission"
                >
                  <label class="inline-checkbox">
                    <input v-if="minPermission.code"
                           v-model="serviceItem.permissions"
                           :value="minPermission.code"
                           type="checkbox"
                           @click="selectPermission(minPermission.code, permission)"
                    >
                    {{ minPermission.name }}
                  </label>

                  <div v-for="subMinPermission in minPermission.children"
                       v-if="minPermission.children" :title="getTitlePermission(minPermission)"
                       class="sub-sub-sub-permission"
                  >
                    <label class="inline-checkbox">
                      <input v-if="subMinPermission.code"
                             v-model="serviceItem.permissions"
                             :value="subMinPermission.code"
                             type="checkbox"
                      >
                      {{ subMinPermission.name }}
                    </label>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
      <div slot="footer">
        <button class="btn btn-default" type="button" @click.prevent="saveAction()">
          <i v-if="processing" class="fas fa-spinner fa-spin"></i>
          <span v-if="isEdit">Save</span>
          <span v-if="!isEdit">Create</span>
        </button>
        <button class="btn btn-default" type="button" @click.prevent="modal = false">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from '../../../client'
import Common from '../../mixins/Common'

export default {
  name: 'ModalNewServiceSetup',
  mixins: [Common],
  components: {},
  props: {
    serviceEdit: {}
  },
  data () {
    return {
      modal: false,
      processing: false,
      serviceItem: {
        name: '',
        permissions: []
      },
      listPermissions: [],
      allSelected: false
    }
  },
  mounted () {
    this.getDetail()
    this.modal = true
    $('#modal-new-setup-package').find('.modal-dialog').addClass('modal-max')
  },
  computed: {
    getTitleModal () {
      if (this.serviceEdit) {
        return 'Edit package'
      }
      return 'Create New Package'
    },
    isEdit () {
      return !!this.serviceEdit
    }
  },
  watch: {
    'modal' (newValue, oldValue) {
      this.$emit('updateModal', newValue)
    }
  },
  updated () {
  },
  methods: {
    selectAll () {
      if (!this.allSelected) {
        this.listPermissions.forEach(permission => {
          let code = permission.code
          if (code && this.serviceItem.permissions.indexOf(code) < 0) {
            this.serviceItem.permissions.push(code)
          }
          if (permission.children && permission.children.length) {
            permission.children.forEach(child => {
              let codeChild = child.code
              if (codeChild && this.serviceItem.permissions.indexOf(codeChild) < 0) {
                this.serviceItem.permissions.push(codeChild)
              }
              if (child.children && child.children.length) {
                child.children.forEach(sub => {
                  let codeSub = sub.code
                  if (codeSub && this.serviceItem.permissions.indexOf(codeSub) < 0) {
                    this.serviceItem.permissions.push(codeSub)
                  }

                  if (sub.children && sub.children.length) {
                    sub.children.forEach(min => {
                      let codeMin = min.code
                      if (codeMin && this.serviceItem.permissions.indexOf(codeMin) < 0) {
                        this.serviceItem.permissions.push(codeMin)
                      }
                    })
                  }
                })
              }
            })
          }
        })
      } else {
        this.serviceItem.permissions = []
      }
    },
    selectPermission (code, mainRole) {
      const isMainRole = code === mainRole.code
      if (isMainRole) {
        // remove main code
        if (this.serviceItem.permissions.indexOf(code) >= 0) {
          const listRemoved = []
          if (mainRole.children) {
            mainRole.children.forEach(child => {
              let codeChild = child.code
              listRemoved.push(codeChild)
              if (child.children && child.children.length) {
                child.children.forEach(sub => {
                  let codeSub = sub.code
                  listRemoved.push(codeSub)
                  if (sub.children && sub.children.length) {
                    sub.children.forEach(min => {
                      let codeMin = min.code
                      listRemoved.push(codeMin)
                    })
                  }
                })
              }
            })
          }
          this.serviceItem.permissions = this.serviceItem.permissions.filter(item => !listRemoved.includes(item))
        }
        return
      }
      if (code && this.serviceItem.permissions.indexOf(code) >= 0) {
        this.allSelected = false
        return
      }
      if (code && this.serviceItem.permissions.indexOf(code) < 0) {
        if (mainRole.code && mainRole && this.serviceItem.permissions.indexOf(mainRole.code) < 0) {
          this.serviceItem.permissions.push(mainRole.code)
        }
      }
    },
    getTitlePermission (item) {
      return item.hover ? item.hover : ''
    },
    async getDetail () {
      try {
        let response = await axios.get(`/setup-package/get-data-create`, {
          params: {
            packageId: this.serviceEdit ? this.serviceEdit._id : ''
          }
        })
        if (response.data.s === 200) {
          this.modal = true
          const serviceItem = response.data.data.service
          if (serviceItem) {
            this.serviceItem.name = serviceItem.name
            this.serviceItem.permissions = serviceItem.permissions
          }
          this.listPermissions = response.data.data.DEFAULT_PERMISSIONS
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        console.log(e.message, ' ==')
        this.alertError('Server error when get data of service.Try again ')
      }
    },
    validateForm () {
      if (!this.serviceItem.name) {
        return { s: false, msg: 'Please enter name' }
      }
      if (this.serviceItem.permissions.length === 0) {
        return { s: false, msg: 'Please choose permission' }
      }
      return { s: true }
    },
    async saveAction () {
      if (this.isEdit) {
        await this.updateService()
        return
      }
      await this.createService()
    },
    async updateService () {
      if (this.processing) {
        return
      }
      let validate = this.validateForm()
      if (!validate.s) {
        this.alertError(validate.msg)
        return
      }
      try {
        this.processing = true
        let data = this.serviceItem
        let response = await axios.put(`/setup-package/${this.serviceEdit._id}`, data)
        this.processing = false
        if (response.data.s === 200) {
          this.$emit('createNew', {})
          this.modal = false
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.processing = false
        this.alertError('Server error.Try again ')
      }
    },
    async createService () {
      if (this.processing) {
        return
      }
      let validate = this.validateForm()
      if (!validate.s) {
        this.alertError(validate.msg)
        return
      }
      try {
        this.processing = true
        let data = this.serviceItem
        let response = await axios.post(`/setup-package`, data)
        this.processing = false
        if (response.data.s === 200) {
          this.$emit('createNew', {})

          this.modal = false
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.processing = false
        this.alertError('Server error.Try again ')
      }
    }
  }
}
</script>
<style>
#modal-new-setup-package .modal-max {
  width: 98% !important;
}
</style>
<style scoped>
label.inline-checkbox {
  padding-right: 0 !important;
}

.item-limit {
  display: block;
  color: #d9df20;
}

.col-item-permission {
  width: 13%;
  float: left;
  display: block;
}

.sub-permission, .sub-sub-permission, .sub-sub-sub-permission {
  margin-left: 15px;
}
</style>
